import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useDomain } from '@useDomain';

import './FabNavbar.css';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

function FabNavbar() {
  const { organization: org } = useDomain();
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const location = useLocation();



  if (!org) return null; // ✅ Move this up before using org.slug

  const hostname = window.location.hostname.replace(/^www\./, '');
  const isCustomDomain = !hostname.includes("localhost") && !hostname.includes("sportinghip.com");
  const basePath = isCustomDomain ? '' : `/${org.slug}`;
  const isHomepage = location.pathname === '/' || location.pathname === `/${org.slug}`;


 const closeMenu = () => {
  setIsClosing(true);
  setTimeout(() => {
   setIsOpen(false);
   setIsClosing(false);
  }, 300); // match CSS transition
 };

 const toggleMenu = () => {
  isOpen ? closeMenu() : setIsOpen(true);
 };

 return (
  <nav className={`navbar_container ${org.theme || 'light'}-theme ${isHomepage ? 'homepage-nav' : ''}`}>
   <div className="navbar_left">
    <NavLink to={`${basePath}`} className="navbar_logo_link" onClick={closeMenu}>
     {org.logo_url ? (
      <img src={org.logo_url} alt="League Logo" className="navbar_logo_image" />
     ) : (
      <span className="navbar_logo_text">{org.name}</span>
     )}
    </NavLink>
   </div>

   <div className="navbar_right">
    <button className="navbar_hamburger" onClick={toggleMenu}>
     {isOpen ? <FaTimes /> : <FaBars />}
    </button>

    <ul className={`navbar_list ${isOpen ? 'open' : ''} ${isClosing ? 'closing' : ''}`}>
     {isOpen && (
      <div className="navbar_close_icon">
       <button onClick={closeMenu}>
        <FaTimes />
       </button>
      </div>
     )}


      <li><NavLink to={`${basePath}`} onClick={closeMenu}>HOME</NavLink></li>
      <li><NavLink to={`${basePath}/registration`} onClick={closeMenu}>REGISTRATION</NavLink></li>
      <li><NavLink to={`${basePath}/leagueInfo`} onClick={closeMenu}>LEAGUE INFO</NavLink></li>
      <li><NavLink to={`${basePath}/tournament`} onClick={closeMenu}>TOURNAMENT</NavLink></li>
      <li><NavLink to={`${basePath}/teamList`} onClick={closeMenu}>STANDINGS</NavLink></li>
      <li><NavLink to={`${basePath}/schedule`} onClick={closeMenu}>SCHEDULE</NavLink></li>
      <li><NavLink to={`${basePath}/playerList`} onClick={closeMenu}>PLAYERS</NavLink></li>
      <li><NavLink to={`${basePath}/leaderboard`} onClick={closeMenu}>LEADER BOARD</NavLink></li>
      <li><NavLink to={`${basePath}/youth`} onClick={closeMenu}>YOUTH</NavLink></li>
      <li><NavLink to={`${basePath}/ourTeam`} onClick={closeMenu}>JOIN OUR TEAM</NavLink></li>
      <li><NavLink to={`${basePath}/leagueFootage`} onClick={closeMenu}>LEAGUE FOOTAGE</NavLink></li>
      <li><NavLink to={`${basePath}/contact`} onClick={closeMenu}>CONTACT US</NavLink></li>
     </ul>

   </div>
  </nav>
 );
}

export default FabNavbar;
